import { render } from "./QCMImage.vue?vue&type=template&id=1e38a2b8&scoped=true"
import script from "./QCMImage.vue?vue&type=script&lang=js"
export * from "./QCMImage.vue?vue&type=script&lang=js"

import "./QCMImage.vue?vue&type=style&index=0&id=1e38a2b8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e38a2b8"]])

export default __exports__